import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, combineLatest } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthFacade } from './core/store/auth/auth.facade';
import { setPortalMode } from './core/store/projects/projects.actions';
import { ProjectsFacade } from './core/store/projects/projects.facade';
import { PVG_PORTAL_KEY } from './core/types/projeto.types';

@Component({
  selector: 'app-prepare-portal',
  template: ``,
})
export class PreparePortalComponent implements OnInit {
  private destroy$ = new Subject<void>();

  domain: string;

  constructor(
    private router: Router,
    private projectsFacade: ProjectsFacade,
    private authFacade: AuthFacade,
    private titleService: Title,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // this.listenToDomain();

    this.listenPortalConfig();
  }

  listenToDomain() {
    const { domain } = this.route.snapshot.params;

    if (!domain) {
      this.router.navigate(['not-found', domain]);
      return;
    }
    this.domain = domain;
    this.authFacade.getPublicTokens(domain);
  }

  listenPortalConfig() {
    combineLatest([
      this.projectsFacade.pvgeoId$.pipe(filter((id) => id !== -1)),
      this.projectsFacade.ouvCollabId$.pipe(filter((id) => id !== -1)),
      this.projectsFacade.icadId$.pipe(filter((id) => id !== -1)),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([pvgeoId, ouvCollaId, icadId]) => {
        if (ouvCollaId && pvgeoId && !icadId) {
          this.titleService.setTitle('Portal O.V.I.');
          this.projectsFacade.dispatch(setPortalMode({ mode: PVG_PORTAL_KEY }));
          this.router.navigate([PVG_PORTAL_KEY, 'map']);
        } else if (icadId && !ouvCollaId && !pvgeoId) {
          this.titleService.setTitle('Portal ICAD');
          this.projectsFacade.dispatch(setPortalMode({ mode: 'icad' }));
          this.router.navigate(['icad', 'map']);
        } else if (ouvCollaId && pvgeoId && icadId) {
          this.titleService.setTitle('Portal ICAD');
          this.projectsFacade.dispatch(setPortalMode({ mode: 'icad' }));
          this.router.navigate(['icad', 'map']);

          // this.router.navigate(['select-mode']);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
